import { render, staticRenderFns } from "./ProfileEdit.vue?vue&type=template&id=518e2752&scoped=true"
import script from "./ProfileEdit.vue?vue&type=script&lang=js"
export * from "./ProfileEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "518e2752",
  null
  
)

export default component.exports